<template>
	<div v-show="show">
		<div class="vx-row w-full" v-if="OptimizationGroupUpdatePermission">
			<div class="vx-col w-full mb-base">
				<OptimizationGroupForm
					:groupProps="data"
					:isEditActive="true"
					@showSidebarEdit="showSidebarEditEmit"
					@refreshList="$emit('refreshList')"
				/>
			</div>
		</div>
		<not-permission v-else></not-permission>
	</div>
</template>
<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import OptimizationGroupForm from "../OptimizationGroupForm.vue";

export default {
	name: "OptimizationGroupUpdate",
	props: {
		data: {
			type: Object,
		},
	},
	components: {
		NotPermission,
		OptimizationGroupForm,
	},
	data() {
		return {
			show: false,
		};
	},
	computed: {
		OptimizationGroupUpdatePermission() {
			return this.$store.getters.checkPermission("OPTIMIZATION_GROUP_U");
		},
	},
	mounted() {
		this.show = true;
	},
	methods: {
		showSidebarEditEmit(val) {
			this.$emit("showSidebarEdit", val);
		},
	},
};
</script>
